import { graphql, useStaticQuery } from 'gatsby';

const useEducacion = () => {

    const data = useStaticQuery(graphql`
        query {
            allDatoCmsEducacion(filter: {}) {
                nodes {
                  titulo,
                  anio,
                  descripcion
                }
            }
        }
    `);

    return data.allDatoCmsEducacion.nodes.map(educacion => ({
        titulo: educacion.titulo,
        anio: educacion.anio,
        descripcion: educacion.descripcion
    }));

}
 
export default useEducacion;